import { render, staticRenderFns } from "./menuForm.vue?vue&type=template&id=20fef943&scoped=true"
import script from "./menuForm.vue?vue&type=script&lang=js"
export * from "./menuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fef943",
  null
  
)

export default component.exports